<template>
<m-navbar :theme="theme.theme.headerTheme">
  <m-navbar-brand>
    <i class="side-switch"
      :class="{
        'el-icon-more': !mini,
        'el-icon-more-outline': mini
      }"
      @click="handleSwitchSide"
      ></i>
  </m-navbar-brand>
  <m-nav align="right">
    <m-nav-item padding="0">
      <m-dropdown align="right" v-if="user" padding="0 10px">
        <a href="#" style="display: inline-block; padding: 0px; color: inherit">
          <i class="fa fa-2x fa-user-circle-o" style="vertical-align: middle;" aria-hidden="true"></i>
          <!--<img src="../../assets/user.jpg" alt="" style="border-radius: 3px;vertical-align: middle;">-->
          <span>{{user}}</span>
          <span class="caret"></span>
        </a>
        <m-dropdown-panel>
          <m-dropdown-item><a href="/user/info">用户信息</a></m-dropdown-item>
          <m-dropdown-item><a href="#" @click="dialogFormVisible = true">修改密码</a></m-dropdown-item>
          <div class="test-line"></div>
          <m-dropdown-item  @click.native.prevent="handleLogout">退出账号</m-dropdown-item>
        </m-dropdown-panel>
      </m-dropdown>
    </m-nav-item>
    <m-nav-item padding="0 5px">
      <a href="#" @click.stop.prevent="handleSwitchScreen">
        <i
          class="fa"
          :class="isFullScreen ? 'fa-compress' : 'fa-expand'"
          ></i>
      </a>
    </m-nav-item>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" :modal-append-to-body='false'>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
        <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPasswd">
          <el-input v-model="ruleForm.oldPasswd" autocomplete="off" type="password" show-password style="width: 65%"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPasswd">
          <el-input v-model="ruleForm.newPasswd" placeholder="输入新密码" type="password" show-password style="width: 65%"></el-input>

        </el-form-item>
        <el-form-item :label-width="formLabelWidth" >
          <div style="line-height:20px">
        1. 密码长度需大于10位小于20位<br/>
        2. 密码需包含大小写字母,数字,特殊字符(!@#*?.)<br/>
        3. 密码有效期为6个月,且不能和旧密码一样
          </div>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="newPasswd1">
          <el-input v-model="ruleForm.newPasswd1" placeholder="确认密码" type="password" show-password style="width: 65%"></el-input>

        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <m-nav-item padding="0">
      <m-dropdown align="right" padding="0 10px">
        <a href="#"  style="padding:0 0px; color: inherit">
          <i class="fa fa-gears"></i>
        </a>
        <m-dropdown-panel style="width: 200px; min-height: 100px;">
          <el-form>
            <el-form-item label="侧边栏">
              <el-switch v-model="showAside" @change="handleSwitchHideSide" />
            </el-form-item>
            <el-form-item label="主题">
              <el-select v-model="themeType" style="width: 100px">
                <el-option
                  v-for="theme in themes"
                  :key="theme.label"
                  :label="theme.label"
                  :value="theme.name"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </m-dropdown-panel>
      </m-dropdown>
    </m-nav-item>
  </m-nav>
</m-navbar>



</template>
<script type="text/javascript">
import {mapActions, mapState} from 'vuex'
import {
  requestFullScreen,
  exitFullscreen
} from '@/utils'
import themes from './theme'

export default {
  name: 'app-header',
  data () {
    var checkPass = ( rule,value,callback) => {
      if ( value === ''){
        callback(new Error('请输入密码'));
      } else {
        callback()
      }
    };
    var checkNewPass =  (rule,value,callback) => {
      if (value === ''){
        callback(new Error('请输入新密码'));
      } else {
        /*
          检查密码复杂度要求
         */
        if ( value.length < 10 || value.length > 20 ){callback(new Error('密码长度需大于10位小于20位')) }
		var s = new RegExp('((?=[\x21-\x7e]+)[^A-Za-z0-9])');
		if ( ! /[a-z]/.test(value) && ! /[A-Z]/.test(value) || ! /[0-9]/.test(value) || ! s.test(value) || /[&=?]/.test(value)){callback(new Error('密码复杂度不够，需包含字母,数字,特殊字符'))};

		if ( this.ruleForm.newPasswd1 !== ''){ this.$refs.ruleForm.validateField('newPasswd1');}
        callback();
      }
    };
    var checkNewPass1 = (rule,value,callback) => {
      if ( value === ''){
        callback(new Error("请在次输入密码"));
      } else if (value !== this.ruleForm.newPasswd) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback();
      }
    }
    return {
      mini: false,
      isFullScreen: false,
      themes,
      themeType: '',
      showAside: true,
      theme: {theme: {headerTheme: 'info'}},
      loading: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      ruleForm: {
        oldPasswd: '',
        newPasswd: '',
        newPasswd1: '',
      },
      rules: {
        oldPasswd: [{trigger:'blur',validator: checkPass}],
        newPasswd: [{trigger:'blur',validator: checkNewPass}],
        newPasswd1: [{trigger:'blur',validator: checkNewPass1}]
      },
      isSame: false,
      formLabelWidth: '140px'

    }
  },
  computed: {
    ...mapState({
      user: ({user}) => user.user
    })
  },
  watch: {
    themeType (val) {
      this.theme = this.themes.find(e => e.name === val) || {}
      this.$emit('set-theme', this.theme)
      localStorage.setItem('theme', val)
    }

  },
  methods: {
    ...mapActions(['getLoginUser', 'newLogout','userPasswordModify']),
    handleSwitchSide () {
      this.mini = !this.mini
      this.$emit('switch', this.mini)
    },
    handleLogout () {
      var params = {"host": window.location.host.split(".")[0] };
      this.newLogout(params).then(res =>{
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push('/login')
        this.success("退出成功")
      }).catch(err => {
      })
    },
    handleSwitchScreen () {
      if (this.isFullScreen) {
        exitFullscreen()
        this.isFullScreen = false
      } else {
        requestFullScreen()
        this.isFullScreen = true
      }
    },
    handleSwitchHideSide () {
      this.$emit('hide-side')
    },
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {

          var params = this.ruleForm;

          this.userPasswordModify(params).then(response => {
            this.success(response.desc);
            this.dialogFormVisible=false;
            localStorage.removeItem("user");
            this.$router.push({ path: '/login/' })

          }).catch(error => {
            this.loading = false;
            this.error(error.desc ? error.desc : '服务器异常')
            this.dialogFormVisible=false;
            this.loading = false
          })
        } else {
          console.log('error submit!!');
          this.loading = false
          return false;
        }
      });
    }

  },
  created () {
    this.getLoginUser()
    var theme = localStorage.getItem('theme') || 'hongyan' // default
    this.themeType = theme
  }
}
</script>
<style type="text/css">
  .side-switch{
    display: inline-block;
    font-size: 32px;
    cursor: pointer;
    color: inherit;
    margin-top: 10px;
  }
  .side-switch:hover{
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/app-header.vue